import { Column } from "primereact/column";
import { DataTable, DataTableDataSelectableParams } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import { Button } from "primereact/button";
import { LeadPOCs } from "./LeadPOCs";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { BlacklistRequestForm } from "./BlacklistRequestForm";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IEmptyFilter } from "./Filter";
import { DraftEmails } from "./DraftEmails";
import { DraftedEmails } from "./DraftedEmails";
import { NewDraftEmaills } from "./NewDraftEmaills";
// interface ILeadScrappingJobs {
//     id?: number,
//     jobTitle?: string,
//     jobUrl?: string,
//     companyName?: string,
//     companyUrl?: string,
//     source?: string,
//     jobType?: string,
//     jobDescription?: string,
//     createdBy?: number,
//     createdAt?: Date,
//     updatedBy?: number,
//     updatedAt?: Date,
// }

interface IPOCs {
    id?: number,
    pocName?: string,
    pocEmail?: string,
    createdAt?: Date,
}

interface IMailHistory {
    id?: number,
    email_Subject?: string,
    email_Body?: string,
    email_CC?: string,
    send_By?: number,
    send_At?: Date,
    jobID?: number,
    pocID?: number,
    poc_Email?: string,
}

interface ILeadScrappingJobs {
    companyName?: string,
    companyUrl?: string,
    createdAt?: Date,
    createdBy?: number,
    id?: number,
    jobDescription?: string,
    jobTitle?: string,
    jobType?: string,
    jobUrl?: string,
    pocCount?: number,
    source?: string,
    pocs?: IPOCs[],
    emails_Sent?: IMailHistory[],
    email_Limit?: number,
}

interface IProps {
    toast: any
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ILeadScrappingJobs>, loading: boolean });
    const [openPOCModel, setOpenPOCModel] = useState({ open: false, singleData: [], job: {} } as { open: boolean, singleData: IPOCs[], job: ILeadScrappingJobs });
    const [openDetailsModel, setOpenDetailsModel] = useState({ open: false, singleData: "", typeName: "" } as { open: boolean, singleData: string, typeName: string });
    const [totalRecords, setTotalRecords] = useState(0);
    const [openBanCompanyModel, setOpenBanCompanyModel] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ILeadScrappingJobs });
    const [openDraftModel, setOpenDraftModel] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ILeadScrappingJobs });
    const [filters, setFilters] = useState<IEmptyFilter>(EmptyFilter);
    const [selectedRows, setSelectedRows] = useState<ILeadScrappingJobs[]>([]);
    const dt = useRef<any>(null);

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        console.log(event);
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams({ ...event, page: event.page + 1 });
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const newFilter = {
            from_Date: filters.fromDate,
            toDate: filters.toDate,
            login_ID: filters.user_Name,
            company: filters.company,
            branch: filters.branch,
            source: filters.source,
            haveReached: filters.haveReached
        }
        const response = await Fetch("lead-capture/jobs", "GET", null, `filter=${encodeURIComponent(JSON.stringify(newFilter))}&pageNumber=${lazyParams.page}&pageSize=${lazyParams.rows}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data.data.items, loading: false });
            setTotalRecords(data.data.totalRecords || 0);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const header = () => {
        return (
            <>
            </>
        )
    };

    const pocS = (rowData: ILeadScrappingJobs) => {
        return <Button label={`${rowData.pocCount}`} onClick={() => setOpenPOCModel({ open: true, singleData: rowData.pocs || [], job: rowData })} className="p-button-rounded p-button-info p-button-text" />
    }

    const sendEmails = (rowData: ILeadScrappingJobs) => {
        if (Number(rowData.email_Limit || "0") <= Number((rowData.emails_Sent || [])?.length)) {
            return <Button label={`Sent ${(rowData.emails_Sent?.length || 0) > 0 ? `(${(rowData.emails_Sent?.length || 0)})` : ""} Emails`} onClick={() => props.toast.current.show({ severity: "warn", detail: "Can't Send More Emails As Per Limit", life: 3000 })} className="p-button-rounded p-button-info p-button-text" />
        }
        else return <Button label={`Draft Emails ${(rowData.emails_Sent?.length || 0) > 0 ? `(${(rowData.emails_Sent?.length || 0)})` : ""}`} onClick={() => setOpenDraftModel({ open: true, singleData: rowData })} className="p-button-rounded p-button-info p-button-text" />
    }

    const blackListRequest = (rowData: ILeadScrappingJobs) => {
        return <Button icon="pi pi-ban" onClick={() => setOpenBanCompanyModel({ open: true, singleData: rowData })} className="p-button-rounded p-button-info p-button-text" />
    }

    const DateFormat = loginObj.date_Format;

    useEffect(() => {
        loadTableData();
    }, [filters, lazyParams]);

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filter={filters} setFilters={(filters: IEmptyFilter) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines resizableColumns scrollable lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData}
                emptyMessage="No Records found."
                header={header}
                loading={tableData.loading}
            // selectionMode={'checkbox'}
            // selection={selectedRows}
            // onSelectionChange={(e) => {
            //     if (selectedRows.length > 10) {
            //         props.toast.current?.show({ severity: "warn", summary: "Limit Exceeded", detail: `You can select up to ${10} emails only`, life: 3000, });
            //     } else {
            //         const value = e.value as ILeadScrappingJobs[];
            //         setSelectedRows(value);
            //     }
            // }}
            >
                {/* <Column selectionMode="multiple" style={{ width: "5rem", minWidth: "5rem", maxWidth: "5rem" }} /> */}
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="source" header="Source" />
                <Column field="companyName" header="Company Name" />
                <Column field="companyUrl" header="Company Url" body={(rowData: ILeadScrappingJobs) => {
                    const companyUrl = rowData.companyUrl || "";
                    const openCompanyUrl = () => {
                        if (!companyUrl) return;
                        const url = /^https?:\/\//i.test(companyUrl) ? companyUrl : `https://${companyUrl}`;
                        window.open(url, "_blank", "noopener,noreferrer");
                    };

                    return (
                        <div className="flex">
                            <Button label={companyUrl} className="p-button-rounded p-button-text p-button-plain"
                                style={{ width: "7rem", background: "transparent", border: "none", outline: "none", boxShadow: "none", color: "#0288d1", }} tooltip={companyUrl || "No URL available"} tooltipOptions={{ position: "top" }} onClick={openCompanyUrl} disabled={!companyUrl}
                            />
                            <span style={{ marginTop: "9px", color: "#0288d1", cursor: companyUrl ? "pointer" : "default", }} onClick={openCompanyUrl} title={companyUrl || "No URL available"}>
                                ...
                            </span>
                        </div>
                    );
                }}
                />

                <Column field="createdAt" header="Created At" body={(rowData: ILeadScrappingJobs) => safeFormatDate(new Date(rowData?.createdAt || "").toDateString(), "dd/MM/yyyy", DateFormat)} />
                <Column field="createdBy" header="Created By" />
                {/* <Column field="id" header="id" /> */}
                <Column field="jobDescription" header="Job Description" body={(rowData: ILeadScrappingJobs) => <div onClick={() => setOpenDetailsModel({ open: true, singleData: (rowData.jobDescription || ""), typeName: "Job Description" })} className="flex"><Button label={rowData.jobDescription} className="p-button-rounded p-button-info p-button-text" style={{ width: "7rem" }} /><span style={{ marginTop: "9px", color: "#0288d1", cursor: "pointer" }}>...</span></div>} />
                <Column field="jobTitle" header="Job Title" body={(rowData: ILeadScrappingJobs) => <div onClick={() => setOpenDetailsModel({ open: true, singleData: (rowData.jobTitle || ""), typeName: "Job Title" })} className="flex"><Button label={rowData.jobTitle} className="p-button-rounded p-button-info p-button-text" style={{ width: "7rem" }} /><span style={{ marginTop: "9px", color: "#0288d1", cursor: "pointer" }}>...</span></div>} />
                <Column field="jobType" header="Job Type" />
                <Column field="jobUrl" header="Job Url" body={(rowData: ILeadScrappingJobs) => {
                    const jobUrl = rowData.jobUrl || ""; const openJobUrl = () => {
                        if (!jobUrl) return;
                        const url = /^https?:\/\//i.test(jobUrl) ? jobUrl : `https://${jobUrl}`;
                        window.open(url, "_blank", "noopener,noreferrer");
                    };

                    return (
                        <div className="flex">
                            <Button label={jobUrl} className="p-button-rounded p-button-text p-button-plain" style={{ width: "7rem", background: "transparent", border: "none", outline: "none", boxShadow: "none", color: "#0288d1", }}
                                tooltip={jobUrl || "No URL available"} tooltipOptions={{ position: "top" }} onClick={openJobUrl} disabled={!jobUrl}
                            />
                            <span style={{ marginTop: "9px", color: "#0288d1", cursor: jobUrl ? "pointer" : "default", }} title={jobUrl || "No URL available"} onClick={openJobUrl}>
                                ...
                            </span>
                        </div>
                    );
                }}
                />

                {/* <Column field="pocCount" header="POC Count" body={pocS} /> */}
                <Column field="" header="Send Emails" headerStyle={{ minWidth: "10rem" }} bodyStyle={{ minWidth: "10rem" }} body={sendEmails} />
                <Column field="" header="" body={blackListRequest} />
            </DataTable>
            <LeadPOCs open={openPOCModel.open} singleData={openPOCModel.singleData} hideDialog={() => setOpenPOCModel({ open: false, singleData: [], job: {} })} job={openPOCModel.job} toast={props.toast} />
            <Dialog visible={openDetailsModel.open} style={{ width: '80vw' }} header={openDetailsModel.typeName} modal className="p-fluid" onHide={() => setOpenDetailsModel({ open: false, singleData: "", typeName: "" })}>
                <Card style={{ overflowY: "scroll", maxHeight: "65vh" }}>
                    {openDetailsModel.singleData}
                </Card>
            </Dialog>
            <BlacklistRequestForm open={openBanCompanyModel.open} singleData={openBanCompanyModel.singleData} hideDialog={() => { setOpenBanCompanyModel({ open: false, singleData: {} }); loadTableData(); }} toast={props.toast} />
            {/* <DraftEmails open={openDraftModel.open} singleData={openDraftModel.singleData} hideDialog={() => setOpenDraftModel({ open: false, singleData: {} })} toast={props.toast} /> */}
            {/* <DraftedEmails open={openDraftModel.open} singleData={openDraftModel.singleData} hideDialog={() => setOpenDraftModel({ open: false, singleData: {} })} toast={props.toast} /> */}
            <NewDraftEmaills open={openDraftModel.open} singleData={openDraftModel.singleData} hideDialog={() => { setOpenDraftModel({ open: false, singleData: {} }); loadTableData(); }} toast={props.toast} />
        </>
    );
}